import {
	UPDATE_NOTIFICATIONS,
	UPDATE_MENSAGENS_CHAT_NAO_LIDAS,
} from "redux/constants/Menu";

const initMenu = {
	notificacoes: [],
	avisos: [],
	chat: 0,
};

const menu = (state = initMenu, action) => {
	switch (action.type) {
		case UPDATE_NOTIFICATIONS:
			return {
				...state,
				notificacoes: action.notificacoes,
				avisos: action.avisos || [],
			};
		case UPDATE_MENSAGENS_CHAT_NAO_LIDAS:
			return {
				...state,
				chat: Math.max(0, Number(action.total) || 0),
			};
		default:
			return state;
	}
};

export default menu;
